import React from 'react';
import * as Styled from './styled';
import { TableCell } from '@leasequery/lq.react-component-library/dist/components/table';
import { InProgressStatus, ExportResult } from '../../../models';
import { fetchRawSnapshot } from '../../../api';
import { downloadFile, FileTypes } from '../../../util';
import { Icon } from '../../../components';

interface ExportToExcelButtonCellProps {
  cell: TableCell;
}

const createExportToExcelButtonCell = () => ({
  cell,
}: ExportToExcelButtonCellProps): JSX.Element => {
  const rowData = cell.row.original as ExportResult;
  // allow export even in error state, only disable if still processing
  const disabled =
    rowData.statusId === InProgressStatus.processingStart ||
    rowData.statusId === InProgressStatus.initiated;

  // TODO: update download to accept whatever filetype the api returns
  const clickHandler = (): void => {
    const fileName = rowData.jsonData.Filename.split(".")[0] || 'Export';

    const fetchExportFile = async (): Promise<void> => {
      const response = await fetchRawSnapshot(rowData.taskId);
      const { type, fileType } =
        rowData.jsonData.Filename.split(".")[1] === 'CSV'
          ? { type: 'text/csv', fileType: FileTypes.csv }
          : { type: 'text/plain', fileType: FileTypes.txt };
      const blob = new Blob([response], { type: type });
      downloadFile(blob, fileName, fileType);
    };

    fetchExportFile();
  };
  const iconName =
    rowData.jsonData.OutputType === 'CSV' ? 'exportToExcel' : 'exportToTxt';
  return rowData.jsonData.OutputType !== 'FTP' ? (
    <Styled.ActionButton onClick={clickHandler} disabled={disabled}>
      <Icon name={iconName} disabled={disabled} />
    </Styled.ActionButton>
  ) : null;
};

export default createExportToExcelButtonCell;
